import Link from 'next/link';

/** The legal lines and nothing else: the recruit link left the footer 2026-09-12. */
export function FooterCard() {
  return (
    <div className="flex flex-col items-center gap-2.5 pb-2 pt-4 text-center">
      <span className="flex gap-3 text-badge text-[var(--sf-ground-faint)]">
        <Link href="/terms">Terms</Link>
        <Link href="/privacy">Privacy</Link>
      </span>
    </div>
  );
}
